export const common = {
  // Navigation
  'nav.home': 'Главная',
  'nav.services': 'Услуги',
  'nav.pricing': 'Цены',
  'nav.about': 'О нас',
  'nav.transfers': 'Наши Трансферы',
  'nav.chambery': 'Аэропорт Шамбери',
  'nav.lyon': 'Аэропорт Лион',
  'nav.blog': 'Блог',
  'nav.contact': 'Контакты',
  'nav.book': 'Забронировать',
  'nav.phone': '+33 6 05 60 60 06',

  // Hero Section
  'hero.title': 'Частные Трансферы на Альпийские Горнолыжные Курорты',
  'hero.subtitle': 'Премиум-сервис из аэропортов Женевы, Лиона и Шамбери до самых красивых горнолыжных курортов Альп',
  'hero.cta.book': 'Забронировать Трансфер',
  'hero.cta.quote': 'Получить Расчет',

  // Services
  'services.title': 'Наши Премиум Услуги',
  'services.subtitle': 'Комфорт и безопасность для всех ваших поездок',
  'services.airport.title': 'Трансферы из Аэропорта',
  'services.airport.desc': 'Прямой сервис из аэропортов Женевы, Лиона и Шамбери',
  'services.private.title': 'Частные Трансферы',
  'services.private.desc': 'Комфортабельные автомобили для 1-8 пассажиров',
  'services.24h.title': 'Доступно 24/7',
  'services.24h.desc': 'Сервис доступен днем и ночью, 7 дней в неделю',
  'services.tracking.title': 'Отслеживание Рейсов',
  'services.tracking.desc': 'Мы отслеживаем ваш рейс для корректировки времени встречи',

  // Destinations
  'destinations.title': 'Популярные Направления',
  'destinations.subtitle': 'Самые красивые горнолыжные курорты Альп',
  'destinations.viewAll': 'Все Направления',
  'destinations.privateTransfer': 'Частный Трансфер',

  // Stats
  'stats.clients': 'Довольных Клиентов',
  'stats.transfers': 'Выполненных Трансферов',
  'stats.destinations': 'Направлений',
  'stats.experience': 'Лет Опыта',

  // Testimonials
  'testimonials.title': 'Отзывы Наших Клиентов',
  'testimonials.subtitle': 'Тысячи довольных путешественников',

  // FAQ
  'faq.title': 'Часто Задаваемые Вопросы',
  'faq.subtitle': 'Все, что вам нужно знать о наших услугах',

  // CTA
  'cta.title': 'Готовы Забронировать Трансфер?',
  'cta.subtitle': 'Получите мгновенный расчет и забронируйте за несколько кликов',
  'cta.button': 'Получить Бесплатный Расчет',

  // Footer
  'footer.description': 'Премиум-сервис частных трансферов на альпийские горнолыжные курорты. Гарантируем комфорт, безопасность и пунктуальность.',
  'footer.services': 'Услуги',
  'footer.destinations': 'Направления',
  'footer.company': 'Компания',
  'footer.contact': 'Контакты',
  'footer.legal': 'Правовая Информация',
  'footer.rights': 'Все права защищены',
  'footer.poweredBy': 'Создание Сайтов',

  // Contact
  'contact.title': 'Свяжитесь с Нами',
  'contact.subtitle': 'Мы здесь, чтобы ответить на все ваши вопросы',
  'contact.form.name': 'Полное Имя',
  'contact.form.email': 'Электронная Почта',
  'contact.form.phone': 'Телефон',
  'contact.form.message': 'Ваше Сообщение',
  'contact.form.submit': 'Отправить Сообщение',
  'contact.form.success': 'Сообщение успешно отправлено!',
  'contact.info.title': 'Контактная Информация',
  'contact.info.phone': 'Телефон',
  'contact.info.email': 'Электронная Почта',
  'contact.info.whatsapp': 'WhatsApp',

  // Booking
  'booking.title': 'Забронировать Трансфер',
  'booking.from': 'Откуда',
  'booking.to': 'Куда',
  'booking.date': 'Дата',
  'booking.time': 'Время',
  'booking.passengers': 'Пассажиры',
  'booking.luggage': 'Багаж',
  'booking.name': 'Полное Имя',
  'booking.email': 'Электронная Почта',
  'booking.phone': 'Телефон',
  'booking.notes': 'Дополнительные Примечания',
  'booking.submit': 'Подтвердить Бронирование',
  'booking.success': 'Бронирование подтверждено!',

  // Common
  'common.from': 'Из',
  'common.to': 'В',
  'common.price': 'Цена',
  'common.duration': 'Длительность',
  'common.distance': 'Расстояние',
  'common.loading': 'Загрузка...',
  'common.error': 'Произошла ошибка',
};

export default common;
